// Utilidades para consultar permisos por bloque dentro de una pantalla.
//
// El backend devuelve en getPantallasByUsuarioId cada pantalla con:
//   - bloques: lista de codigos de permiso aplicables a esa pantalla
//     (declarados en el parametro de la pantalla)
//   - permisosOtorgados: lista de permisos concedidos al usuario
//     (por nombre) para esa pantalla, resolviendo todos sus roles.
//
// Regla de visibilidad:
//   - Si la pantalla no declara "bloques" -> se muestran todos (backcompat).
//   - Si declara bloques -> el bloque X se muestra solo si esta en permisosOtorgados.

const KEY_PANTALLAS = 'pantallas';

function getPantallas() {
    try {
        const raw = localStorage.getItem(KEY_PANTALLAS);
        return raw ? JSON.parse(raw) : [];
    } catch (e) {
        return [];
    }
}

// Encuentra la pantalla activa por alguno de: componente, dirUrl, path.
export function getPantallaActiva({ componente, dirUrl, path } = {}) {
    const lst = getPantallas();
    return lst.find(p =>
        (componente && p.componente === componente) ||
        (dirUrl && p.dirUrl === dirUrl) ||
        (path && p.path === path)
    );
}

// Devuelve una funcion puedeVer(codigoBloque) para la pantalla indicada.
// Reglas:
//   - Pantalla sin bloques declarados -> acceso total.
//   - Bloques declarados pero el usuario no tiene ninguno otorgado de esos
//     bloques -> acceso total (backcompat: el admin aun no configuro la restriccion).
//   - Bloques declarados y al menos uno otorgado -> solo se muestran los otorgados.
//   - Codigos fuera de la lista de bloques declarados no se controlan.
export function buildPuedeVer(pantalla) {
    if (!pantalla) return () => true;
    const bloques = Array.isArray(pantalla.bloques) ? pantalla.bloques : [];
    const otorgados = Array.isArray(pantalla.permisosOtorgados) ? pantalla.permisosOtorgados : [];
    if (bloques.length === 0) return () => true;
    const tieneAlgunoOtorgado = bloques.some(b => otorgados.includes(b));
    if (!tieneAlgunoOtorgado) return () => true;
    return (codigo) => {
        if (!codigo) return true;
        if (!bloques.includes(codigo)) return true;
        return otorgados.includes(codigo);
    };
}

// Atajo: obtener puedeVer directamente por componente.
export function puedeVerPorComponente(componente) {
    return buildPuedeVer(getPantallaActiva({ componente }));
}
